import React from 'react'
import { useState } from 'react';
import {Link} from 'gatsby'

import CmpFilterList from "./CmpFilterList"
import ChartMensualXRubro from "./ChartMensualXRubro"

const RptMensualXRubro = (props) => {
  const [filter, setFilter] =  useState({key: 'TiendasYOcio', label: 'Tiendas y Ocio'});
  const [chartType, setChartType] =  useState('line');
  const [filters, setFilters] = useState({'filter2': [], 'filter3': [], 'filter4': []})
  const [filterDataset, setFilterDataset] = useState({filterName: 'label', value: 'Nacional'})

  
  const filterList = [
    {key: 'TiendasYOcio', label: 'Tiendas y Ocio'},
    {key: 'SupermercadosYFarmacias', label: 'Supermercados y Farmacias'},
    {key: 'Parques', label: 'Parques'},
    {key: 'Transporte', label: 'Transporte'},
    {key: 'EspaciosDeTranajo', label: 'Espacios de Trabajo'},
  ];
  // setFilter(filterList[0]);

  function onFilterSelected(vfilter, e){
    setFilter(vfilter);
    // e.preventDefault();
  }
  function onFiltersLoaded(loadedFilters, e){
    setFilters(loadedFilters)
  }

  function applyDatasetFilter(filterName, value){
    setFilterDataset({filterName: filterName, value: value})
  }

  return(
    
    <div className="row">
    
      <div className="col-lg-3">
        <CmpFilterList value={filter} filters={filterList} onChangeValue={onFilterSelected}></CmpFilterList>

        <div className="widget-area small" style={{'margin-top': '1.5em'}}>          
            <div className="widget widget_tag_cloud">

                <h3 className="widget-title">Región geográfica</h3>                
                <div className="tagcloud">
                  <Link to="#" onClick={(e) => {applyDatasetFilter('filter2', null); e.preventDefault();} }> Todos </Link>                

                  {filters['filter2'].map((item) => {
                  return <Link to="#" onClick={(e) => {applyDatasetFilter('filter2', item); e.preventDefault();} }> {item} </Link>
                  })}
                </div>
            </div>

            <div className="widget widget_tag_cloud">
                <h3 className="widget-title">Ciudad turística de playa</h3>                
                <div className="tagcloud">
                  <Link to="#" onClick={(e) => {applyDatasetFilter('filter3', null); e.preventDefault();} }> Todos </Link>

                  {filters['filter3'].map((item) => {
                  return <Link to="#" onClick={(e) => {applyDatasetFilter('filter3', item); e.preventDefault();} }> {item} </Link>
                  })}
                </div>                
            </div>

            <div className="widget widget_tag_cloud">
                <h3 className="widget-title">Grandes ciudades</h3>                
                <div className="tagcloud">
                  <Link to="#" onClick={(e) => {applyDatasetFilter('filter4', null); e.preventDefault();} }> Todos </Link>

                  {filters['filter4'].map((item) => {
                  return <Link to="#" onClick={(e) => {applyDatasetFilter('filter4', item); e.preventDefault();} }> {item} </Link>
                  })}
                </div>                
            </div>

          </div>

      </div>
      <div className="col-lg-9">
        <div className="rpt-chart-types">
            <a className="default-btn small" href="#/" onClick={(e) => {setChartType('bar'); e.preventDefault();} }><i className="flaticon-view"></i>Bar</a>
            <a className="default-btn small" href="#/" onClick={(e) => {setChartType('line'); e.preventDefault();} }><i className="flaticon-view"></i>Line</a>
        </div>
        <ChartMensualXRubro value="" filter={filter} chartType={`${chartType}`} onFiltersLoaded={onFiltersLoaded} filterDatasets={filterDataset}></ChartMensualXRubro>
      </div>
    </div>
    
  )


}

export default RptMensualXRubro